import React from 'react';
import { SignableOfferFeed } from '../../../../../entities/ApplicationFeed';
import { User } from '../../../../../entities/User';
import { Application } from '../../../../../entities/Application';
import { AlertObject } from '../../../../../components/Alert';
import { GenericEntry } from '../..';
import { ViewOfferButton } from '../ViewOfferButton';

interface PropTypes {
  application: Application;
  currentUser: User;
  isLastItemInPage: boolean;
  entry: SignableOfferFeed;
  setAlert: (data: AlertObject) => void;
  reloadFeed: () => void;
}

export function SignableOfferRejected(props: PropTypes) {
  return (
    <GenericEntry
      icon='bi-x-circle'
      iconClassName='bg-light-danger'
      title={
        <span>
          <strong>{props.entry.signableOfferDeclinedBy}</strong> has declined
          the <strong>{props.application.job.name}</strong> Offer with the
          following reason.
        </span>
      }
      date={props.entry.createdAt}
      {...props}
    >
      <>
        {props.entry.signableOfferDeclineReason && (
          <div className='bg-gray rounded-3 my-3 p-3'>
            {props.entry.signableOfferDeclineReason}
          </div>
        )}
        <ViewOfferButton entry={props.entry} />
      </>
    </GenericEntry>
  );
}
